export const GLX_PRODUCTION__FETCH_SERIES_LIST = 'GLX_PRODUCTION__FETCH_SERIES_LIST';
export const GLX_PRODUCTION__FETCH_SERIES_LIST_SUCCEEDED = 'GLX_PRODUCTION__FETCH_SERIES_LIST_SUCCEEDED';
export const GLX_PRODUCTION__FETCH_SERIES_LIST_FAILED = 'GLX_PRODUCTION__FETCH_SERIES_LIST_FAILED';
